<template>
    <div class="changelog-container">
        <v-container fluid class="form-content overflow-auto pa-5">
            <h4>TODO</h4>
        </v-container>

        <div class="kontakt-content pa-5"></div>
    </div>
</template>

<script>
import { formRules } from '@/helpers/tools';
import { Address } from '@/models/Address';
import GlobalsMixin from '@/mixins/globals';

export default {
    name: 'AddressEditChangelog',
    mixins: [GlobalsMixin],
    props: {
        record: {
            type: Address,
            required: true,
        },
        // used to indicate form validity
        value: Boolean,
    },
    created() {
        this.rules = formRules;
    },
    methods: {
        // can / will be called from the parent component to initiate a forceful form validation
        validateForm() {
            // this.$refs.form.validate();
        },
        onInput(field, value) {
            this.record.set(field, value);
        },
    },
};
</script>

<style lang="scss" scoped>
.changelog-container {
    display: grid;
    grid-template-columns: auto minmax(400px, auto);
    grid-template-areas: 'form kontakte';
}

.form-content {
    grid-area: form;
    overflow: auto;
}

.kontakt-content {
    grid-area: kontakte;
    background-color: var(--toolbar-bg-color);
    overflow: auto;
}
</style>
